import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgComponent } from '@shared/components/svg';
import { StoreWithUuid } from '@shared/models';
import { TransformFirstLetterPipe } from '@shared/pipe';
import { FunnelSlotSelected } from '@stores/models';

@Component({
  selector: 'app-appointment-details',
  imports: [TranslatePipe, TransformFirstLetterPipe, NgClass, NgTemplateOutlet, SvgComponent],
  templateUrl: './appointment-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentDetailsComponent {
  storeSelected = input.required<StoreWithUuid>();
  slotSelected = input.required<FunnelSlotSelected>();
  canEdit = input(false);
  fullHeight = input(false);
  /** The confirmation screen: green, with stickers. */
  confirmed = input(false);
  onStoreChange = output();
  onSlotChange = output();
}
